module.exports = __webpack_public_path__ + "img/logo-qinlian.5ecd76c7.png";